// 环境变量配置集中管理，避免在业务代码中分散读取
export const envConfig = {
    assetBase: process.env.VUE_APP_ASSET_BASE ?? ''
};
export default envConfig;
